import { render, staticRenderFns } from "./newCheckIcon.vue?vue&type=template&id=83de1792&scoped=true"
import script from "./newCheckIcon.vue?vue&type=script&lang=js"
export * from "./newCheckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83de1792",
  null
  
)

export default component.exports